import { applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'

import { testingMiddleware } from 'embed/middleware/Testing'
import { trackingMiddleware } from 'embed/middleware/Tracking'
import unleashContextMiddleware from 'embed/middleware/UnleashContext'
import { ExperimentCohortMap } from 'embed/experiment'

import { Unleash } from 'embed/experiment/unleash'
import { experimentMiddleware } from 'embed/experiment/middleware'
import { isDev } from 'embed/constants/config'

import datadogMiddleware from 'embed/services/Datadog/redux-middleware'
import Parent from 'embed/services/Parent'
import Tracker from 'embed/services/Tracker'

import Session from 'embed/services/Session'

const unleashService = new Unleash()

const multiProductTrackingMiddleware = trackingMiddleware(Tracker, Parent)
const multiProductTestingMiddleware = testingMiddleware()
const multiProductUnleashContextMiddleware = unleashContextMiddleware(unleashService, Session, ExperimentCohortMap)

export const middleware = isDev
  ? composeWithDevTools(
      applyMiddleware(
        thunkMiddleware,
        experimentMiddleware,
        createLogger(),
        multiProductTrackingMiddleware,
        datadogMiddleware,
        multiProductTestingMiddleware,
        multiProductUnleashContextMiddleware,
      ),
    )
  : applyMiddleware(
      thunkMiddleware,
      experimentMiddleware,
      multiProductTrackingMiddleware,
      datadogMiddleware,
      multiProductUnleashContextMiddleware,
    )
